var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"visible":_vm.visible,"title":_vm.title,"size":"xl","modal-class":"document-viewer","hide-footer":""},on:{"hide":_vm.hide}},[_c('iframe',{staticClass:"document-viewer-frame",attrs:{"src":_vm.src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }